<template>
    <VanCell center class="in-panel">
        <template #title>
            <div class="flex-row flex-space-between flex-y-center student">
                <div class="flex-row">
                    <div class="image">
                        <img :src="order.student.avatarUrl | resourceUrl" ref="student" class="avatar"
                             @error="handleRefAvatarError('student', order.student.gender)">
                    </div>
                    <div class="info">
                        <div class="fs15px">{{ order.student.name }}</div>
                        <div class="classes txt-gray" >{{ className }}</div>
                        <div v-if='order.student.coin > 0'>
                            <span>米币抵扣：</span>
                            <span>{{(order.student.coin / order.mideCoinExchange).toFixed(2) || 0}}元</span>
                            <span>（{{order.student.coin}}米币）</span>
                        </div>
                        <div>
                            <span> {{order.order ? '已付合计':'应付合计'}}：</span>
                            <span class="txt-red">{{(order.goods.price - (order.student.coin / order.mideCoinExchange)).toFixed(2) || 0}} 元</span>
                        </div>
                        <div v-if="order.order" class="txt-gray">{{ order.order.payTime }}</div>
                    </div>
                </div>
            </div>
        </template>
    </VanCell>
</template>

<script>
    import RefAvatarErrorHandler from '../../../mixins/RefAvatarErrorHandler';

    export default {
        name: 'StudentCard',
        mixins: [RefAvatarErrorHandler],
        computed: {
            className() {
                return this.order.student.classes.map((m) => m.name).join('/');
            },
        },
        props: {
            order: {
                type: Object,
                default() {
                    return {};
                },
            },
            payment: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
    };
</script>

<style scoped lang="less">
& .classes {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.avatar {
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 50%;
    background-color: #eeffee;
    border: 1px solid #f1f6f1;
    display: block;
    text-align: center;
    line-height: 4.4rem;
    margin-right: 1rem;
}
</style>
